export default "__VITE_ASSET__g2Js1hL6__"